<script>

   /*************************************************************/
   /* ResultsTable                                              */
   /* -------------------------                                 */
   /* shows table with PCA results for new datset               */
   /*************************************************************/

   // main properties of the whole app
   export let res;

   const NCOMPMAX = 16;
   let expvar, cumexpvar;
   $: if (res) {
      cumexpvar = res.stat.cumexpvar;
      expvar = res.stat.expvar;
   }
</script>


{#if res}
<table>
   <tr>
      <th>PC</th>
      <th>Expvar</th>
      <th>Cumexpvar</th>
   </tr>
   {#each res.stat.components.filter(v => v < NCOMPMAX) as a}
   <tr>
      <td>{a}</td>
      <td>{(expvar[a - 1] * 100).toFixed(2)}</td>
      <td>{(cumexpvar[a - 1] * 100).toFixed(2)}</td>
   </tr>
   {/each}

   {#if res.ncomp > NCOMPMAX}
   <tr>
      <td>...</td>
      <td>...</td>
      <td>...</td>
   </tr>
   {/if}

   {#if res.ncomp >= NCOMPMAX}
   <tr>
      <td>{res.ncomp}</td>
      <td>{((cumexpvar[res.ncomp - 1] - cumexpvar[res.ncomp - 2]) * 100).toFixed(2)}</td>
      <td>{(cumexpvar[res.ncomp - 1] * 100).toFixed(2)}</td>
   </tr>
   {/if}
   </table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }
</style>